/**
 * Tracking helpers — safe by design.
 * These calls are no-ops until the corresponding script (fbq / gtag) is loaded,
 * which only happens after explicit user consent via <ConsentScripts />.
 */

export const trackFbEvent = (event, params = {}) => {
  if (typeof window !== "undefined" && window.fbq) {
    try {
      window.fbq("track", event, params);
    } catch (e) {
      // silent — never break the user flow on tracking errors
    }
  }
};

export const trackGaEvent = (event, params = {}) => {
  if (typeof window !== "undefined" && window.gtag) {
    try {
      window.gtag("event", event, params);
    } catch (e) {
      // silent
    }
  }
};
